import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InstantBookingDataService from "../../services/InstantBooking"
import { SingleInstantRow } from "../../components/List/SingleInstantRow";
export const InstantList = () => {
    const navigate = useNavigate();

    const [list, setList] = useState<any>();
  
   
  
    const isNgodelete = (isdelete: true) => {
      fetchData();
    };
  
    const fetchData = async () => {
      InstantBookingDataService.getBookings()
        .then((res: any) => {
          setList(res.data);
        })
        .catch((error: any) => {
          console.log(error);
        });
    };
    useEffect(() => {
      fetchData();
    }, []);
    return (
      <div className="main-wrapper p-3">
        <div className="container-fluid bg-white rounded p-4">
  
          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  <th>Booking Id</th>
                  <th>Lead Name</th>
                  <th>Expert Name</th>
                  <th>Session Date</th>
                  <th>Session Time</th>
                  <th>Booking Type</th>
                  <th>View</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list && list.length>0
                  ? list.map((el: any) => (
                      <SingleInstantRow
                        key={el._id}
                        props={el}
                        id={el._id}
                        func={isNgodelete}
                      />
                    ))
                  :   <h1 className="no-data" >No Data Found</h1>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };